import { all, create } from 'mathjs';

const MAX = (a: number[], ...args: number[]) => {
  const math = create(all);
  return math.max(a, ...args);
};

export default MAX;
